import { bool, func, shape, string } from 'prop-types'
import { UnwrappedButton } from '../Button'
import Conditional from '../Conditional'
import { kuiperClassNames } from '../utils'
import './styles.scss'

const cancel = ({ onCancel, onCloseFromModal }) => {
  onCancel()
  onCloseFromModal()
}

const FormFooter = ({
  animateInfo,
  cancelText,
  disableSubmit,
  formMeta = {
    title: '',
    info: '',
    warn: false,
    error: false,
  },
  infoRef,
  onCancel = () => {},
  onSubmit,
  submitText = 'Submit',
  onCloseFromModal = () => {},
}) => (
  <div className={kuiperClassNames('form-footer')}>
    <Conditional condition={Boolean(formMeta.info)}>
      <div
        aria-live="polite"
        className={kuiperClassNames('form-details', {
          warning: formMeta.warn,
          error: formMeta.error,
        })}
      >
        <span className={kuiperClassNames('form-detail-title')}>
          {formMeta.title}
        </span>
        <span
          className={kuiperClassNames('form-detail-info', {
            flicker: animateInfo,
          })}
          ref={infoRef}
        >
          {formMeta.info}
        </span>
      </div>
    </Conditional>
    <Conditional condition={Boolean(cancelText)}>
      <UnwrappedButton
        className={kuiperClassNames('form-cancel')}
        label={cancelText}
        onClick={() => cancel({ onCancel, onCloseFromModal })}
        type="invisible"
      />
    </Conditional>
    <UnwrappedButton
      disabled={disableSubmit}
      label={submitText}
      onClick={onSubmit}
    />
  </div>
)

FormFooter.propTypes = {
  animateInfo: bool,
  cancelText: string,
  disableSubmit: bool,
  formMeta: shape({
    title: string,
    info: string,
    warn: bool,
  }),
  infoRef: func,
  onCancel: func,
  onCloseFromModal: func,
  onSubmit: func,
  submitText: string,
}

export default FormFooter
